import {
    IconCardHexagon, IconChipDepartment,
    IconPlusFill, PersonOutlinedChip
} from "../../../../components/buttons/IconButtons";
import SummaryItem from "./SummaryItem";
import CustomTooltip from "../../../../components/CustomTooltip";
import React from "react";
import {EMPTY_VALUES} from "../../../../Apis/functions";
import CustomCard from "../../../../components/CustomCard";
import NotInformation from "../../../../components/NotInformation";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 04 de 05 de 2026
 */

const SummaryContainerDepaFA = ({t, selectDepa}) => {

    const rightItems = selectDepa.slice(0, 4);
    const leftItems = selectDepa.slice(4, 7);
    const extraCount = selectDepa.length;

    return (
        <CustomCard className="p-3" classes="card-border-8px" classContent="p-0 overflow-hidden">
            <div className="d-flex align-items-center p-3">
                <div><IconChipDepartment /></div>
                <div className="ml-2">
                    <p className="font-color-general-950 ibl-font-w-600 fs-14px">{t('departments')}</p>
                </div>
            </div>
            <div className="border-bottom-shades-300" />
            {
                selectDepa.length <= 0
                    ? <NotInformation text={t('no_custom_access_assigned')} card={true} />
                    : <div className={"row p-12px"}>
                        <div className={"maxw-5 col-1 p-0 d-none d-md-block"}>
                            <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center
                align-items-center w-44px h-44px'>
                                <IconCardHexagon width={24} height={24}/>
                            </div>
                        </div>
                        <div className={"col-12 col-md-11 row p-0"}>
                            <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                                {rightItems.map((item) => (
                                    <SummaryItem
                                        label={item.fullName}
                                        value={
                                            <div className={"col-12 col-md-6 flex-row justify-content-end align-items-baseline p-0"}>
                                                <div className={"mr-8px"}><PersonOutlinedChip/></div>
                                                <div className={"flex-grow-1 minw-0"}>
                                                    <CustomTooltip
                                                        text={item?.totalEmployees && EMPTY_VALUES.DEFAULT_NUMBER}
                                                        classes={`fs-12px text-ellipsis-1-row`}
                                                        showIfTruncated={true}
                                                    />
                                                </div>
                                            </div>
                                        }
                                        t={t}
                                        className={'d-flex justify-content-between'}
                                        classNameValue={'w-300px justify-items-end '}
                                    />
                                ))}
                            </div>
                            <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                                {leftItems.map((item) => (
                                    <SummaryItem
                                        label={item.fullName}
                                        value={
                                            <div className={"col-12 col-md-6 flex-row justify-content-end align-items-baseline p-0"}>
                                                <div className={"mr-8px"}><PersonOutlinedChip/></div>
                                                <div className={"flex-grow-1 minw-0"}>
                                                    <CustomTooltip
                                                        text={item?.totalEmployees && EMPTY_VALUES.DEFAULT_NUMBER}
                                                        classes={`fs-12px text-ellipsis-1-row`}
                                                        showIfTruncated={true}
                                                    />
                                                </div>
                                            </div>
                                        }
                                        t={t}
                                        className={'d-flex justify-content-between'}
                                        classNameValue={'w-300px justify-items-end'}
                                    />
                                ))}

                                {extraCount > 0 && (
                                    <SummaryItem
                                        label={'total_added_departments'}
                                        className={'background-shades-100'}
                                        value={
                                            <div className={"col-12 col-md-6 flex-row justify-content-start align-items-baseline p-0 pr-3"}>
                                                <div className={"mr-8px"}><IconPlusFill/></div>
                                                <div className={"flex-grow-1 minw-0"}>
                                                    <CustomTooltip
                                                        text={extraCount}
                                                        classes={`fs-12px text-ellipsis-1-row`}
                                                        showIfTruncated={true}
                                                    />
                                                </div>
                                            </div>
                                        }
                                        t={t}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
            }

        </CustomCard>
    )

}
export default SummaryContainerDepaFA

